import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/search.svg` */
export const SearchSolidIcon = createTripletGlyphIcon('SearchSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.61816 1.76465C9.30821 1.76475 11.4893 3.94375 11.4893 6.63086C11.4892 7.76509 11.0987 8.8074 10.4473 9.63477L13.8691 13.1426C14.0812 13.36 14.0768 13.7088 13.8594 13.9209C13.6419 14.133 13.2931 14.1286 13.0811 13.9111L9.6748 10.417C8.83889 11.0912 7.77623 11.4961 6.61816 11.4961C3.92809 11.4961 1.74716 9.31796 1.74707 6.63086C1.74707 3.94368 3.92804 1.76465 6.61816 1.76465Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.44531 1.98535C10.4717 1.9854 12.9248 4.43692 12.9248 7.45996C12.9247 8.73586 12.4857 9.90815 11.7529 10.8389L15.6504 14.835C15.8624 15.0524 15.858 15.4002 15.6406 15.6123C15.4232 15.8244 15.0754 15.82 14.8633 15.6025L10.9902 11.6318C10.0345 12.4429 8.79757 12.9336 7.44531 12.9336C4.41908 12.9336 1.96608 10.4828 1.96582 7.45996C1.96582 4.43689 4.41892 1.98535 7.44531 1.98535Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.92676 2.64746C13.962 2.64746 17.2334 5.91553 17.2334 9.94629C17.2333 11.6476 16.648 13.2111 15.6709 14.4521L20.8555 19.7686C21.1445 20.0651 21.1393 20.5399 20.8428 20.8291C20.5463 21.1182 20.0714 21.1117 19.7822 20.8154L14.6279 15.5303C13.3571 16.5988 11.7179 17.2441 9.92676 17.2441C5.89174 17.244 2.62025 13.9769 2.62012 9.94629C2.62012 5.9156 5.89166 2.64757 9.92676 2.64746Z"
        fill="currentColor"
      />
    </svg>
  ),
});
